import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { COMMUNITY_APPROVAL_LIMIT } from "./apiRoutes";

interface UseGetCommunityApprovalLimitProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityApprovalLimit = async (communityId: string, year: string) =>
  await axiosAuth.get(`${COMMUNITY_APPROVAL_LIMIT}/${communityId}/${year}`);

const useGetCommunityApprovalLimit = ({
  queryParams,
  communityId,
  year,
}: UseGetCommunityApprovalLimitProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["Community-approval-limit", communityId, year],
    queryFn: () => getCommunityApprovalLimit(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId || !!year || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetCommunityApprovalLimit;
